import { Link } from "react-router-dom";
import { PageHero } from "../components/shared/Primitives";
import { UserPlus, Search, CheckCircle2, ArrowRight, Sparkles } from "lucide-react";

const CREATE_POINTS = [
  "Publish a profile families can find directly",
  "Respond to Care Needs and receive private enquiries & invitations",
  "Free — no payment needed to be discovered or access work opportunities",
];

const BROWSE_POINTS = [
  "See carers who've published an approved profile",
  "Reach out to a carer without sharing your contact details upfront",
  "Free to browse with a Just Care Community family account",
];

export default function CarerProfilesLanding() {
  return (
    <div data-testid="page-carer-profiles-landing">
      <PageHero
        eyebrow="Carer Profiles"
        title="Carers — create your profile free."
        description="Create your JCC carer profile, be discovered by families and respond to Care Needs — without paying JCC for access to work opportunities."
        accent="purple"
      />
      <section className="section">
        <div className="container-jcc grid md:grid-cols-2 gap-6">
          <Link
            to="/carer-profile/post"
            className="group card-base p-8 flex flex-col hover:border-purple hover:-translate-y-1 transition-all duration-200"
            data-testid="carer-profiles-landing-create-cta"
          >
            <div className="w-12 h-12 rounded-2xl bg-purple/10 text-purple flex items-center justify-center">
              <UserPlus className="w-6 h-6" strokeWidth={1.75} />
            </div>
            <h2 className="mt-5 font-display text-2xl font-bold">Create your profile free</h2>
            <p className="mt-2 text-ink-muted leading-relaxed">
              I'm a carer — I want families to be able to find and contact me.
            </p>
            <ul className="mt-5 space-y-2.5 flex-1">
              {CREATE_POINTS.map((pt) => (
                <li key={pt} className="flex gap-2.5 text-sm text-ink-muted leading-relaxed">
                  <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-purple" strokeWidth={1.75} />
                  <span>{pt}</span>
                </li>
              ))}
            </ul>
            <span className="mt-6 btn-purple inline-flex w-fit">
              Create My Carer Profile — free <ArrowRight className="w-4 h-4" />
            </span>
          </Link>

          <Link
            to="/family/carer-profiles"
            className="group card-base p-8 flex flex-col hover:border-teal hover:-translate-y-1 transition-all duration-200"
            data-testid="carer-profiles-landing-browse-cta"
          >
            <div className="w-12 h-12 rounded-2xl bg-teal/10 text-teal flex items-center justify-center">
              <Search className="w-6 h-6" strokeWidth={1.75} />
            </div>
            <h2 className="mt-5 font-display text-2xl font-bold">Browse Carer Profiles</h2>
            <p className="mt-2 text-ink-muted leading-relaxed">
              I'm a family — I want to see carers who've published a profile.
            </p>
            <ul className="mt-5 space-y-2.5 flex-1">
              {BROWSE_POINTS.map((pt) => (
                <li key={pt} className="flex gap-2.5 text-sm text-ink-muted leading-relaxed">
                  <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-teal" strokeWidth={1.75} />
                  <span>{pt}</span>
                </li>
              ))}
            </ul>
            <span className="mt-6 btn-teal inline-flex w-fit">
              Browse Carer Profiles <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        </div>

        <div className="container-jcc mt-8 max-w-3xl">
          <div className="rounded-2xl border border-purple/15 bg-purple/5 p-5 flex items-start gap-3" data-testid="carer-profiles-landing-optional-paid">
            <Sparkles className="w-5 h-5 text-purple shrink-0 mt-0.5" strokeWidth={1.75} />
            <p className="text-sm text-ink-muted leading-relaxed">
              Want extra support once you're set up? <Link to="/membership/carer-essentials" className="font-semibold text-purple underline">Carer Essentials</Link> (£7/month)
              keeps your professional admin organised, and <Link to="/membership/pro-carer-circle" className="font-semibold text-purple underline">Pro Carer Office</Link> (£19/month)
              adds professional tools and support — both entirely optional, never required to create your profile or respond to Care Needs.
            </p>
          </div>
        </div>

        <p className="container-jcc text-center text-sm text-ink-soft mt-8">
          Already have a Carer Profile? <Link to="/auth/handover/request" className="underline hover:text-ink">Sign in</Link> to manage it.
        </p>
      </section>
    </div>
  );
}
